<template>
    <div>
        <div class="container order-content">
            <div class="manage-main">
                <div class="rule" style="overflow: hidden">
                    <Menu></Menu>
                    <div class="manage-right">
                        <div class="right-title">团房需求</div>
                        <div class="search-result">
                            <div class="search-result-head">
                                <p>搜索到<span class="price">{{total}}</span>条符合条件的订单</p>
                            </div>
                            <table class="result-table" id="table">
                                <thead>
                                <tr>
                                    <td style="width:130px;min-width: 160px">需求类型<br/>名称/目的地<br/>创建时间</td>
                                    <td style="width:55px;">间数</td>
                                    <td style="width:110px;max-width: 125px">房型早餐</td>
                                    <td style="width:100px;min-width: 100px">入住日期<br/>离店日期</td>
                                    <td style="width:80px;">单间预算</td>
                                    <td style="width:170px;">联系人信息</td>
                                    <td style="width:80px;">状态</td>
                                    <td style="width:130px;">关联订单号</td>
                                </tr>
                                </thead>
                                <tbody v-if="!isLoading">
                                <tr v-for="(item,i) in List" @mousemove="showRemark(i)" @mouseout="remarkIndex=''">
                                    <td>
                                        <span class="ellips">{{item.DestnType==0?'酒店':'目的地'}}</span><br>
                                        <span style="width: 130px" class="ellips" :title="item.Destn">{{item.Destn}}</span><br>
                                        <span style="color: #999" class="ellips">{{item.CreateOn|dateToYMDline}} {{item.CreateOn|dateHMS}}</span>
                                    </td>
                                    <td>{{item.RoomCount}}</td>
                                    <td>
                                        <span>大床*{{item.BigBedRoomCount}} {{item.BigBedBFType==0?'无早':item.BigBedBFType==1?'单早':item.BigBedBFType==2?'双早':''}}</span><br>
                                        <span>双床*{{item.DoubleBedRoomCount}} {{item.DoubleBedBFType==0?'无早':item.DoubleBedBFType==1?'单早':item.DoubleBedBFType==2?'双早':''}}</span>
                                    </td>
                                    <td><span>{{item.CheckIn|dateToYMDline}}</span><br><span>{{item.CheckOut|dateToYMDline}}</span></td>
                                    <td>
                                        {{item.Budget}}
                                    </td>
                                    <td>
                                        <span class="ellips" :title="item.ContactName">姓名：{{item.ContactName}}</span><br>
                                        <span class="ellips" :title="item.ContactNumber">手机：{{item.ContactNumber}}</span><br>
                                        <span class="ellips" :title="item.ContactEmail">邮箱：{{item.ContactEmail}}</span>
                                    </td>
                                    <td>
                                        <span v-if="item.Status == 0||!item.Status">等待接单</span>
                                        <span v-if="item.Status == 1">已报价</span>
                                        <span v-if="item.Status == 2">订单处理</span>
                                        <span v-if="item.Status == 3">订单完成</span>
                                        <span v-if="item.Status == 4">接单失败</span>
                                    </td>
                                    <td class="table-remark">
                                        {{item.OrderNO}}
                                        <div v-if="i === remarkIndex"><span>备注：</span>{{item.Remark||'无'}}</div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="table-loading" v-if="isLoading">
                                <Loading :isLoading="isLoading"></Loading>
                            </div>
                            <div class="table-no-more" style="width: 100%" v-if="!isLoading&&total ==0">
                                暂无数据...
                            </div>
                        </div>
                        <Paginate :pageIndex="Page" :pageTotal="Math.ceil(total/PageSize)" @select="pageSelect" v-if="total>10"></Paginate>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from './../../common/cmpnt/datePicker/datePicker.vue'//日期
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import Menu from './../../common/cmpnt/menu/Menu'
    import Paginate from './../../common/cmpnt/paginate/paginate.vue'//分页


    export default {
        name: "orderList",
        components: {
            DatePicker,
            Loading,
            Menu,
            Paginate
        },
        data: function () {
            return {
                List: [],
                total: 0,
                Page: 1,
                PageSize: 10,
                isLoading: false,
                remarkIndex:'',
            }
        },
        mounted() {
            this.initData();
            document.title='团房预订---订房易';

        },
        methods: {
            showRemark(i){
              this.remarkIndex = i;
            },
            // 选择页数
            pageSelect(val){
                this.total=0;
                this.List=[];
                this.Page=val;
                this.initData();
            },
            initData() {
                var that = this;
                that.isLoading = true;
                var params = {
                    Page:that.Page,
                    PageSize:that.PageSize
                }
                that.postRequest({
                    url: that.Api.getTF,
                    params: params
                }).then(res => {
                    this.isLoading = false;
                    if (res && res.IsSuccess) {
                        that.total = res.Total;
                        that.List = res.Result;
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }         
                        })
                    } else {

                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/regimentRoom/List.vue